import { useAuth } from '../context/AuthContext'
import { BILLING_MODE, ENTITLEMENT_COLLECTION, legacyActive } from '../lib/access'

// Test/preview builds only (VITE_BILLING_MODE=test): shows who is signed in and
// why Premium is on or off, so a preview can't be mistaken for a signed-in test.
//
// It leads with TEST MODE and names the collection being read, because the
// mistake worth preventing is the opposite of the obvious one: not "is this a
// preview" but "am I looking at real customer data". A preview reads
// entitlementsTest; production reads entitlements. Nothing but this banner
// distinguishes them on screen.
export default function PreviewStatus() {
  const { user, loading, login, isPremium, isTester, hasAccountSubscription, subscription } = useAuth()
  if (BILLING_MODE !== 'test') return null

  const reasons = [
    hasAccountSubscription && `${ENTITLEMENT_COLLECTION}: kidase active`,
    legacyActive(subscription) && 'legacy subscription',
    isTester && 'tester list',
  ].filter(Boolean)

  // Sticky and above everything: the welcome screen (z-index 9999) and the
  // settings and upgrade overlays (10000) are fixed and full-viewport, and the
  // welcome screen hid this banner completely. A warning that disappears
  // behind the first screen a tester sees is worse than none, because it looks
  // like it is working.
  return (
    <div data-testid="test-mode-banner" style={{
      position: 'sticky', top: 0, zIndex: 2147483000,
      background: '#B86616', color: '#FFFFFF', fontSize: '0.875rem',
      padding: '8px 12px', textAlign: 'center', fontWeight: 600,
      letterSpacing: '0.01em', borderBottom: '2px solid #8D4A0C',
    }}>
      <strong>TEST MODE</strong>{' · '}reading <code>{ENTITLEMENT_COLLECTION}</code>{' · '}
      {loading ? 'checking sign-in…' : !user ? (
        <>Not signed in. <button onClick={login} style={{ font: 'inherit', color: 'inherit', textDecoration: 'underline', background: 'none', border: 0, cursor: 'pointer', padding: 0, minHeight: 'auto' }}>Sign in</button></>
      ) : (
        <>Signed in as {user.email} · Premium: <strong>{isPremium ? 'YES' : 'no'}</strong>
          {isPremium ? ` (${reasons.join(', ')})` : ` (no ${ENTITLEMENT_COLLECTION} kidase entitlement)`}</>
      )}
    </div>
  )
}
